var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.469668 0.868105C0.176777 1.161 0.176777 1.63588 0.469668 1.92877L7.1893 8.64844L0.469668 15.3681C0.176777 15.661 0.176777 16.1358 0.469668 16.4287C0.762558 16.7216 1.23744 16.7216 1.53033 16.4287L8.7803 9.17874C9.0732 8.88584 9.0732 8.41104 8.7803 8.11813L1.53033 0.868105C1.23744 0.575215 0.762558 0.575215 0.469668 0.868105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.7e8800ef9806baff801edc419d6a4f12.svg";
export { ForwardRef as ReactComponent };